module.exports = __webpack_public_path__ + "img/linkedin.8146bce6.svg";